/* eslint-disable object-property-newline */
import { nanoid } from 'nanoid';
import storage from './storage';
import { SURROUND_AUDIO_SUFFIX } from '../../common/constants';

export function isInteger(n) {
  return typeof n === 'number' && Math.floor(n) === n;
}

export function getDeviceId() {
  try {
    let deviceId = storage.getItem('deviceId');

    if (!deviceId) {
      deviceId = nanoid();
      storage.setItem('deviceId', deviceId);
    }

    return deviceId;
  } catch (err) {
    return nanoid();
  }
}

const CANCELED_STATE = Symbol('canceled');
export function createCancellablePromise(resolver) {
  let cancel = null;
  const promise = new Promise((resolve, reject) => {
    cancel = () => resolve(CANCELED_STATE);
    resolver(resolve, reject);
  });
  promise.cancel = cancel;
  promise.CANCELED_STATE = CANCELED_STATE;

  return promise;
}

export function getChannelPlayable(viewable) {
  // Channel
  if (viewable?.__typename === 'Channel') {
    return viewable?.playable;
  }
  // Show/Program/Movie with broadcast playable
  if (viewable?.defaultPlayable?.channel?.playable) {
    return viewable.defaultPlayable.channel.playable;
  }

  return {};
}

// en-6CH -> en
export const getLanguage = (label = '') => label.replace(SURROUND_AUDIO_SUFFIX, '');
// return true if ..-6CH in label
export const has6Channels = (label = '') => label.endsWith(SURROUND_AUDIO_SUFFIX);
// find track by lang and channels
export const findTracksByLang = (tracks, lang, surround) => tracks.filter(track => getLanguage(track.language) === lang
  && ((surround && has6Channels(track.language)) || (!surround && !has6Channels(track.language))));
